import { canonicalizeTagValue, normalizeCategoryType } from './tagValueUtils';

// Frontend mirror of the backend carrier predicate (table_triage.table_carries_pack_attributes):
// a pack-attributed file may only be routed into tables that declare every pack
// category as an attribute column. Only attributeColumns admit — a pack key equal to
// the identifier would be broadcast over the mapped identifier on every row, and a key
// equal to a table-attribute constant would override the declared constant.
// An empty/absent pack map admits every table.
export function tableCarriesPackAttributes(table, packAttributeMap) {
  if (!packAttributeMap || Object.keys(packAttributeMap).length === 0) return true;
  const names = new Set((table?.attributeColumns || []).map(col => col.name));
  return Object.keys(packAttributeMap).every(category => names.has(category));
}

// The pack pairs whose value is not one of their category's type — a stored
// value that predates the calendar check, picked from the list. An upload
// carrying one would fail at the mandatory checkpoint or land as null, so it
// must not start (M209). Each entry names the category, the value as shown,
// and the type it failed.
export function invalidPackAttributes(packAttributes, categories) {
  const typeById = new Map((categories || []).map((category) => [category.id, category.type]));
  return (packAttributes || []).flatMap((tag) => {
    const type = normalizeCategoryType(typeById.get(tag.category));
    try {
      canonicalizeTagValue(tag.value, type);
      return [];
    } catch (error) {
      return [{ category: tag.category, label: String(tag.label ?? tag.value), type }];
    }
  });
}
